import { makeStyles } from '@material-ui/core/';

const styles = makeStyles(({ spacing, breakpoints }) => ({
  title: {
    fontSize: '40px',
  },
  box: {
    padding: `${spacing(3)}px`,
    marginTop: '30px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '5px',
    minWidth: '80%',
    [breakpoints.down('xs')]: {
      minWidth: '100%',
    },
  },
  divider: {
    margin: '16px',
  },
}));

export default styles;
